module.exports = "/_next/static/images/23f0ea26a4c2b6b9a154a24967dd9f94-value-proposal-md-2x.png.webp";